/* global process */

// GET with Promise
import get from '../plugins/get';

export default () => {

  $(window).on('load', () => {

    setTimeout(() => {
      toggleText();

      $('.js-recently-viewed-open a').on('mouseenter mouseleave', (e) => {

        if (e.type === 'mouseenter') {
          toggleText();
        } else {

          setTimeout(() => {
            toggleText();
          }, 250);
        }

      });
    }, 3000);

  });

  const recentCommunities = JSON.parse(localStorage.getItem('recentBrightviewCommunities'));

  if (typeof (Storage) !== 'undefined' && recentCommunities) {

    if (recentCommunities.length) {

      $('.js-recently-viewed-open').show();

      get(process.env.COMMUNITIES_ENDPOINT).then(JSON.parse).then((communities) => {

        communities.find(({id, url, shortTitle, city, state, image}) => {

          if (recentCommunities.indexOf(id) >= 0) {
            const recentPanelItem = `
              <a tabindex="0" class="recently-viewed-item" href="${url}">
                <div class="recently-viewed-item-inner">
                  <div class="recently-viewed-item-info">
                    <h5 class="recently-viewed-item-title">${shortTitle}</h5>
                    <div class="recently-viewed-item-location">${city}, ${state}</div>
                    <span class="btn -bordered">View Community</span>
                  </div>
                  <div class="recently-viewed-item-image" style="background-image: url('${image}');"></div>
                </div>
              </a>`;

            // append location panel items to the pane
            $('.recently-viewed-items').prepend(recentPanelItem);
          }
        });

      });

    }
  }

  $('html')
    // Open recently viewed panel
    .on('click', '.js-recently-viewed-open a, .js-recently-viewed-mobile-open', (e) => {
      e.preventDefault();
      $('html').attr('data-recent-open', 'true');
      $('.js-recently-viewed-open a').trigger('blur');
    })
    // Close recently viewed panel
    .on('click', '.js-recently-viewed-close', (e) => {
      e.preventDefault();
      $('html').attr('data-recent-open', 'false');
    })
    .on('keydown', (e) => {
      if (e.keyCode === 27) {
        $('html').attr('data-recent-open', 'false');
      }
    })
    .on('click', (e) => {
      if (!$(e.target).closest('.js-recently-viewed-open a, .recently-viewed-inner, .js-recently-viewed-mobile-open').length) {
        $('html').attr('data-recent-open', 'false');
      }
    })
  ;

  if ($('.community-landing-hero').length) {
    if (typeof (Storage) !== 'undefined') {
      const oldRecentCommunities = JSON.parse(localStorage.getItem('recentBrightviewCommunities')) || [];
      const communityId = $('.community-landing-hero').data('community');

      if (oldRecentCommunities.indexOf(communityId) === -1) {
        const slicedCommunities = oldRecentCommunities.slice(0, 2);
        slicedCommunities.unshift(communityId);
        localStorage.setItem('recentBrightviewCommunities', JSON.stringify(slicedCommunities));
      }
    }
  }

};

function toggleText() {
  $('.utility-nav-item-recently-viewed-text').animate({width: 'toggle'});
  $('.js-recently-viewed-open').toggleClass('-visible');
}
